import { render, staticRenderFns } from "./account-new.vue?vue&type=template&id=294c85b3&scoped=true&"
import script from "./account-new.vue?vue&type=script&lang=js&"
export * from "./account-new.vue?vue&type=script&lang=js&"
import style0 from "./account-new.vue?vue&type=style&index=0&id=294c85b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c85b3",
  null
  
)

export default component.exports